import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { FormDetails, FormField } from '../../../common/models/form-details.model';
import { prepareUrlObject } from '@vfde-fe/ngx-lib/utils';
import { API_URLS } from '../../../common/constants/routes-config';
import { Helper } from '@vfde-fe/ngx-lib/services/helper-utils';
import { JSON_PATHS } from 'src/app/common/constants/mapping.defines';
import { CHECK_FILE_UPLOAD_MANDATORY } from 'src/app/common/constants/Defines';
declare let jsonpath: any;

/** FormDetailsResolver */
@Injectable({
    providedIn: 'root',
})
export class FormDetailsResolver implements Resolve<FormDetails> {

    /** FormDetails */
    public formDetails: FormDetails = {} as FormDetails;
    public constructor (private httpClient: HttpClient, public helper: Helper) { }

    /** resolve */
    public resolve (route: ActivatedRouteSnapshot): Observable<FormDetails> | any {

      const formId = +route.params['id'];
      const httpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
      const dxlUrlObject = this.helper.prepareURLForDXL(httpHeaders, API_URLS.FORM_DETAILS.FORM_DETAILS_GET);
      const urlObject = prepareUrlObject(dxlUrlObject, {id: formId});
      const requestOptions = { headers: httpHeaders };

      return this.httpClient.get(urlObject, requestOptions).pipe(
        map((response: any) => {
          this.mapToFormDetails(response);

          return this.formDetails;
        }),
      );
    }
    /** mapToFormDetails
     * @method mapToFormDetails
     * @param result: JSON
     * @description maps the result to form details object
     * @returns null
     */
    public mapToFormDetails (response: any) {
      this.formDetails.formInfo = {
        id: jsonpath.value(response, JSON_PATHS.FORM_CENTER.FORM_DETAILS.FORM_INFO.ID),
        name: jsonpath.value(response, JSON_PATHS.FORM_CENTER.FORM_DETAILS.FORM_INFO.NAME),
        key: jsonpath.value(response, JSON_PATHS.FORM_CENTER.FORM_DETAILS.FORM_INFO.KEY),
        stack: jsonpath.value(response, JSON_PATHS.FORM_CENTER.FORM_DETAILS.FORM_INFO.STACK),
        confirmationText: jsonpath.value(response, JSON_PATHS.FORM_CENTER.FORM_DETAILS.FORM_INFO.CONFIRMATION_TEXT),
      };
      this.formDetails.formFields = new Array<FormField>();
      this.formDetails.fileUpload = jsonpath.value(response, JSON_PATHS.FORM_CENTER.FORM_DETAILS.FILE_UPLOAD);
      for (const formField of response.components) {
        if (formField) {
          const field: FormField = {
            id: jsonpath.value(formField, JSON_PATHS.FORM_CENTER.FORM_DETAILS.FORM_FIELD.ID),
            name: jsonpath.value(formField, JSON_PATHS.FORM_CENTER.FORM_DETAILS.FORM_FIELD.NAME),
            order: jsonpath.value(formField, JSON_PATHS.FORM_CENTER.FORM_DETAILS.FORM_FIELD.ORDER),
            type: jsonpath.value(formField, JSON_PATHS.FORM_CENTER.FORM_DETAILS.FORM_FIELD.TYPE),
            value: jsonpath.value(formField, JSON_PATHS.FORM_CENTER.FORM_DETAILS.FORM_FIELD.VALUE),
            label: jsonpath.value(formField, JSON_PATHS.FORM_CENTER.FORM_DETAILS.FORM_FIELD.LABEL),
            placeholder: jsonpath.value(formField, JSON_PATHS.FORM_CENTER.FORM_DETAILS.FORM_FIELD.PLACEHOLDER),
            hint: jsonpath.value(formField, JSON_PATHS.FORM_CENTER.FORM_DETAILS.FORM_FIELD.HINT),
            required: jsonpath.value(formField, JSON_PATHS.FORM_CENTER.FORM_DETAILS.FORM_FIELD.REQUIRED),
            errorText: jsonpath.value(formField, JSON_PATHS.FORM_CENTER.FORM_DETAILS.FORM_FIELD.ERROR_TEXT),
            hide: jsonpath.value(formField, JSON_PATHS.FORM_CENTER.FORM_DETAILS.FORM_FIELD.HIDE),
            constraints: jsonpath.value(formField, JSON_PATHS.FORM_CENTER.FORM_DETAILS.FORM_FIELD.CONSTRAINTS),
            items: jsonpath.value(formField, JSON_PATHS.FORM_CENTER.FORM_DETAILS.FORM_FIELD.ITEMS),
            maxLength: jsonpath.value(formField, JSON_PATHS.FORM_CENTER.FORM_DETAILS.FORM_FIELD.MAX_LENGTH),
            minLength: jsonpath.value(formField, JSON_PATHS.FORM_CENTER.FORM_DETAILS.FORM_FIELD.MIN_LENGTH),
            link: jsonpath.value(formField, JSON_PATHS.FORM_CENTER.FORM_DETAILS.FORM_FIELD.LINK),
          };
          this.formDetails.formFields.push(field);
        }
      }
      /** init the value for upload component */
      const uploadField: FormField = {
        type: 'upload',
        required: this.formDetails.fileUpload === CHECK_FILE_UPLOAD_MANDATORY,
      }
      /** sort the form fields by order */
      this.formDetails.formFields.sort((first, second) => first.order - second.order);

      /** add upload component at the end of data */
      this.formDetails.formFields.push(uploadField);
      /** make the headline the first array object */
      // this.formDetails.formFields.unshift(headlineField);
    }
}
